"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _safeMin=_interopRequireDefault(require("./safe-min"));var _safeMax=_interopRequireDefault(require("./safe-max"));var extent=function extent(arr,fn){if(arr===void 0){arr=[]}return[(0,_safeMin.default)(arr,fn),(0,_safeMax.default)(arr,fn)]};var _default=extent;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/array/extent.js
// module id = 66yp
// module chunks = 5